import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';

/** Contenitore delle notifiche. Montato una sola volta nello shell. */
@Component({
  selector: 'app-toaster',
  template: `
    <div class="stack" aria-live="polite" aria-atomic="false">
      @for (toast of toasts(); track toast.id) {
        <div class="toast" [class.toast-error]="toast.kind === 'error'">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            @if (toast.kind === 'success') {
              <path d="m5 13 4 4L19 7" stroke-linecap="round" stroke-linejoin="round" />
            } @else {
              <circle cx="12" cy="12" r="9" />
              <path d="M12 8v5M12 16.5v.01" stroke-linecap="round" />
            }
          </svg>
          <span class="message">{{ toast.message }}</span>
          <button
            type="button"
            class="close"
            aria-label="Chiudi"
            (click)="toast_.dismiss(toast.id)"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6 6 18M6 6l12 12" stroke-linecap="round" />
            </svg>
          </button>
        </div>
      }
    </div>
  `,
  styleUrl: './toaster.scss',
})
export class Toaster {
  protected toast_ = inject(ToastService);
  protected readonly toasts = this.toast_.toasts;
}
